import MainLayout from "Layouts/Main";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import {
  getAllSubModuleQuestions_USER,
  getPreviousAnswerData,
} from "../../../../Redux/Slices/User/userSlice";
import ProgressBar from "Components/Progressbar";
import PendingIcon from "../../../../Assets/Svg/Auth/PendingAssessment.svg";
import InProgressIcon from "../../../../Assets/Svg/Auth/InProgressAssessment.svg";
import CompletedIcon from "../../../../Assets/Svg/Auth/CompletedAssessment.svg";
import "./styles.scss";
import QuestionaryComponent from "Components/QuestionaryComponent";
import { useLocation, useParams } from "react-router-dom";
import NumberStepper from "Components/NumberStepper";
import Loader from "Components/Loader";
import scrollToTop from "Services/Utils/scrolltoTop";
import Button from "Components/Button";

const PreAssessmentQuestion = () => {
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [categoryIndex, setCategoryIndex] = useState(0);
  const [subCategoryIndex, setSubCategoryIndex] = useState(0);
  const [isAnswered, setIsAnswered] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);
  const { backlog_id } = useParams();
  const [isSubModuleClicked, setisSubModuleClicked] = useState(false)
  const [isLoading, setIsLoading] = useState(true);
  const [openSubmitModal, setOpenSubmitModal] = useState(false);


  const formMethods = useForm({
    defaultValues: {
      categories: [],
    },
  });
  const { watch, setValue } = formMethods;
  const dispatch = useDispatch();
  const categories = watch("categories");

  const location = useLocation();
  const { companyName, assessmentId, completionPercentage } =
    location.state || {};

  useEffect(() => {
    getAllCategories();
  }, []);

  const getAllCategories = () => {
    setIsLoading(true);
    dispatch(
      getAllSubModuleQuestions_USER({
        callBack: (data) => {
          getAllData(data);
          setIsLoading(false);
        },
      })
    );
  };

  const getAllData = (data) => {
    data = data?.map((item) => {
      return {
        ...item,
        isAnswered: false,
        sub_categories: [
          ...item?.sub_categories?.map((element, index) => {
            return {
              ...element,
              questions: element?.questions?.map((y) => {
                return {
                  ...y,
                  notes: "",
                  bearingOption: "",
                  options: y?.options?.map((z) => {
                    return {
                      ...z,
                      isChecked: false,
                    };
                  }),
                };
              }),

              isCompleted: false,
              isRequired: false,
            };
          }),
          {
            subCategory_id: item?.sub_categories?.length + 1,
            subCategory_name: "Additional insights",
            mediaFiles: "",
            comments: "",
            questions: [],
            isCompleted: false,
            isRequired: false,
          },
          {
            subCategory_id: item?.sub_categories?.length + 2,
            subCategory_name: "Feedback",
            comment: "",
            rating: [],
            isFeedback: true,
            isCompleted: false,
            isRequired: false,
          },
        ],
      };
    });

    setValue("categories", data);
    if (data.length > 0) {
      setSelectedCategoryId(data[0].category_id);
    }
  };

  useEffect(() => {
    if (!categories.length) return;
    if (completionPercentage < 0) return;

    if (categories.length) {      
      if (completionPercentage < 100) {
        getPreviousAnswerDetails();
      }
    }
  }, [categories.length, completionPercentage]);

  const handleAfterSkipSave = async () => {
    try {
      await new Promise(resolve => setTimeout(resolve, 500));
      await getPreviousAnswerDetails();
    } catch (err) {
      console.error("error", err);
    }
  };



  const getPreviousAnswerDetails = async () => {
    dispatch(
      getPreviousAnswerData({
        assessment_id: assessmentId,
        callBack: getPreviousDetails,
      })
    );
  };

  const getPreviousDetails = (data) => {
    const previousData = data?.responseData;
    const previousInsightsData = data?.insightdata;

    const updatedSubmoduleData = categories.map((submodule) => ({
      ...submodule,
      isAnswered: data?.result?.find(
        (item) => item?.category_id === submodule?.category_id
      )?.is_answered || false,
      sub_categories: submodule.sub_categories.map((subCategory) => {
        if (subCategory?.subCategory_name === "Additional insights") {
          const matchingInsight = previousInsightsData?.find(
            (prev) => prev.category_id === submodule?.category_id
          );

          const mediaFiles = matchingInsight?.media_files?.map((fileUrl) => {
            const fileName = fileUrl.split("---")[1];
            const decodedFileName = decodeURIComponent(fileName);

            return {
              name: decodedFileName,
              url: fileUrl,
            };
          });

          return {
            ...subCategory,
            mediaFiles,
            comments: matchingInsight?.comments,
            isCompleted: !!(matchingInsight?.media_files || matchingInsight?.comments),
          };
        }
        if (subCategory?.subCategory_name === "Feedback") {
          const feedbackForThisCategory = data?.UserFeedbacks?.find(
            (fb) => Number(fb.categoryId) === Number(submodule.category_id)
          );
          const hasComment = feedbackForThisCategory?.comment?.replace(/<[^>]+>/g, "").trim().length > 0;
          const hasRating = Number(feedbackForThisCategory?.rating) > 0;

          return {
            ...subCategory,
            comment: feedbackForThisCategory?.comment || "",
            rating: feedbackForThisCategory?.rating || 0,
            isCompleted: hasComment || hasRating,
          };
        }

        else {
          return {
            ...subCategory,
            isCompleted: previousData.some(
              (prev) =>
                prev.sub_category_id === subCategory?.subCategory_id &&
                ((prev.question_id && !prev.is_not_required) || prev.text_answer)
            ),
            isRequired: previousData.some((prev) => prev.sub_category_id === subCategory?.subCategory_id && prev?.is_not_required),
            questions: subCategory.questions.map((question) => {
              // Get all previous answers for this question
              const matchingPreviousAnswers = previousData?.filter(
                (prev) => prev?.question_id === question?.question_id
              );

              if (question.is_bearing_size) {
                // Initialize bearingSizeAnswers object
                const bearingSizeAnswers = {
                  small: null,
                  medium: null,
                  large: null
                };

                // Populate bearingSizeAnswers based on previous data
                matchingPreviousAnswers?.forEach((answer) => {
                  if (answer.bearing_size) {
                    const size = answer.bearing_size.toLowerCase();
                    // Find the index of the selected option
                    const optionIndex = question.options.findIndex(
                      option => Number(option.option_id) === Number(answer.option_id)
                    );
                    if (optionIndex !== -1) {
                      bearingSizeAnswers[size] = optionIndex;
                    }
                  }
                });

                return {
                  ...question,
                  notes: matchingPreviousAnswers?.[0]?.notes || "",
                  bearingSizeAnswers,
                  options: question.options.map((option) => ({
                    ...option,
                    isChecked: false // Base options aren't checked for bearing size questions
                  })),
                };
              } else {
                // Handle non-bearing size questions as before
                const matchingPrevious = matchingPreviousAnswers?.[0];
                return {
                  ...question,
                  notes: matchingPrevious?.notes || "",
                  bearingOption: matchingPrevious?.bearing_size || "",
                  options: question.options.map((option) => {
                    const isChecked = previousData.some(
                      (prev) =>
                        prev.question_id === question.question_id &&
                        Number(prev.option_id) === Number(option.option_id)
                    );
                    return {
                      ...option,
                      isChecked,
                    };
                  }),
                };
              }
            }),
          };
        }
      }),
    }));

    setValue("categories", updatedSubmoduleData);
  };

  const handleCategoryClick = (category_id, index) => {
    setSelectedCategoryId(category_id);
    setCategoryIndex(index);
    setSuccessOpen(false);
    setSubCategoryIndex(0);
  };

  const filteredSubCategories = categories?.find(
    (cat) => cat?.category_id === selectedCategoryId
  )?.sub_categories;



  return (
    <MainLayout>
      {isLoading ? (
        <div className="loader-wrapper" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
          <Loader /> {/* Your existing Loader component */}
        </div>
      ) : (
        <>
          <div className="view-module-wrap">
            {categories?.map((item, categoryIndex) => (
              <div
                key={categoryIndex}
                className={`moduleLabel ${selectedCategoryId === item?.category_id ? "active" : ""
                  }`}
                onClick={() => {
                  handleCategoryClick(item?.category_id, categoryIndex)
                  scrollToTop('.container-sidebar')
                }

                }
              >
                {item?.category_name}
              </div>
            ))}
             <div className="submit-btn-wrapper" style={{marginBottom : "0px"}}>

                <Button
                title="Submit"
                buttonStyle={{
                  padding: "8px 16px",
                  cursor: "pointer",
                  backgroundColor: "#1f2155",
                  border: "solid 1px grey",
                  height: "51px",
                  width: "150px",
                  // marginBottom:"20px"
                }}
                titleStyle={{
                  fontSize: "16px",
                  fontWeight: "normal",
                  color: "white",
                }}               
                onClick={() => setOpenSubmitModal(true)} 
              /></div>
          </div>
          <div className="container-main">
            <div className="container-sidebar">
              <div style={{ paddingBottom: "20px" }}>
               
                <h4>Sub-modules</h4>
                {filteredSubCategories?.map((list, index) => {
                  const isFeedback = list?.subCategory_name === "Feedback";
                  const isAdditional = list?.subCategory_name === "Additional insights";

                  const isClickable = list?.isCompleted || isFeedback || isAdditional;

                  return (
                    <div key={index} style={{ height: "120px" }}>
                      <div className="progressbar-container">
                        <img
                          src={
                            list?.isCompleted
                              ? CompletedIcon
                              : index === subCategoryIndex
                                ? InProgressIcon : list?.isRequired ? PendingIcon
                                  : PendingIcon
                          }
                          alt={list.status}
                          width="21"
                          height="21"
                        />
                        <ProgressBar
                          fillColor={"#1f2155"}
                          ProgressBarStyle={{ height: "4px" }}
                          completedPercentage={list?.isCompleted ? 100 : 0}
                        />
                      </div>
                      <div style={{ marginTop: "-7px" }}>


                        <div className="module-title my-2" style={{ cursor: "pointer", display: "flex", gap: "10px" }}  // Optional: show pointer cursor
                          onClick={() => {
                            if (!isClickable) return;
                            setSubCategoryIndex(index)
                            setisSubModuleClicked(true)
                            scrollToTop()
                          }}>
                          {<span>{(list?.subCategory_name !== "Feedback" && list?.subCategory_name !== "Additional insights") && list?.subCategory_id}</span>}
                          {list?.subCategory_name}
                        </div>
                        <div className={`module-status ${list?.isRequired &&
                            list?.subCategory_name !== "Feedback" &&
                            list?.subCategory_name !== "Additional insights"
                            ? "not-required"
                            : ""
                          }`}>
                          {list?.isCompleted
                            ? "Completed"
                            : index === subCategoryIndex
                              ? "Inprogress"
                              : list?.isRequired &&
                                list?.subCategory_name !== "Feedback" &&
                                list?.subCategory_name !== "Additional insights"
                                ? "Not required"
                                : list?.subCategory_name === "Feedback" ||
                                  list?.subCategory_name === "Additional insights" ? "Optional" : "Pending"}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="container-questions">
              <QuestionaryComponent
                currentSubCategory={filteredSubCategories}
                setSubCategoryIndex={setSubCategoryIndex}
                subCategoryIndex={subCategoryIndex}
                categories={categories}
                selectedCategoryId={selectedCategoryId}
                setSelectedCategoryId={setSelectedCategoryId}
                categoryIndex={categoryIndex}
                setCategoryIndex={setCategoryIndex}
                formMethods={formMethods}
                companyName={companyName}
                assessmentId={assessmentId}
                isAnswered={isAnswered}
                backlog_id={backlog_id}
                successOpen={successOpen}
                setSuccessOpen={setSuccessOpen}
                isCompleted={filteredSubCategories}
                isSubModuleClicked={isSubModuleClicked}
                onAfterSkipSave={handleAfterSkipSave}
                 openSubmitModal={openSubmitModal}
                  setOpenSubmitModal={setOpenSubmitModal}
              />
            </div>
          </div>
        </>
      )
      }
    </MainLayout >
  );
};

export default PreAssessmentQuestion;
